const call = {
    pathType: {
        set(type) {
            sessionStorage.setItem('pathType', type)
        },
        get() {
            return  sessionStorage.getItem('pathType')
        },
        remove() {
            sessionStorage.removeItem('pathType')
        }
    },
    clearAll() {
        sessionStorage.clear()
    }
}

export default call
